"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitizeValue = sanitizeValue;
exports.makeOptionsFromPropertyWithoutBlankOptions = makeOptionsFromPropertyWithoutBlankOptions;
exports.makeOptionsFromProperty = makeOptionsFromProperty;
exports.getDisplayedValue = getDisplayedValue;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _I18n = _interopRequireDefault(require("I18n"));

var _NonDecimalRegex = _interopRequireDefault(require("PatternValidationJS/regex/NonDecimalRegex"));

var PropertyIdentifier = _interopRequireWildcard(require("customer-data-objects/property/PropertyIdentifier"));

var _propertyTranslator = require("property-translator/propertyTranslator");

var toOptions = function toOptions(property) {
  return property.options.map(function (option) {
    return {
      text: (0, _propertyTranslator.propertyLabelTranslatorWithIsHubSpotDefined)({
        label: option.label,
        isHubSpotDefined: property.hubspotDefined
      }),
      value: option.value
    };
  }).toJS();
};

var MULTI_VALUE_SEPARATOR_REGEX = /; ?/;

function sanitizeValue(property, value) {
  if (typeof value === 'string') {
    if (PropertyIdentifier.isEnum(property)) {
      value = ("" + value).replace(/\r\n/g, '\n').trim();
    }

    if (PropertyIdentifier.isCurrency(property) || PropertyIdentifier.isNumber(property)) {
      value = value.replace(_NonDecimalRegex.default, '').trim();
    }
  }

  return value;
} //if the dropdown is allowed to be cleared, use makeOptionsFromProperty


function makeOptionsFromPropertyWithoutBlankOptions(property) {
  return toOptions(property);
}

function makeOptionsFromProperty(property) {
  var options = [];
  var placeholder = (0, _propertyTranslator.propertyLabelTranslatorWithIsHubSpotDefined)({
    label: property.placeholder,
    isHubSpotDefined: property.hubspotDefined
  });
  var optionsArrFromProperties = toOptions(property);
  var hasBlankOption = property.options.some(function (option) {
    return option.value === '';
  });

  if (!hasBlankOption) {
    var placeholderOption = {
      text: placeholder,
      value: ''
    };
    options = [placeholderOption].concat((0, _toConsumableArray2.default)(optionsArrFromProperties));
  } else {
    options = optionsArrFromProperties;
  }

  return options;
}

function getDisplayedValue(property, value, choices) {
  var displayValue;

  if (value == null) {
    value = '';
  }

  var propIsMultienum = PropertyIdentifier.isMultienum(property);

  if (PropertyIdentifier.isEnum(property) || propIsMultienum) {
    var selectedItems;

    if (propIsMultienum) {
      selectedItems = value.split(MULTI_VALUE_SEPARATOR_REGEX).filter(function (val) {
        return val !== '';
      });
    }

    if (choices == null) {
      choices = makeOptionsFromProperty(property);
    }

    var selected = choices.filter(function (choice) {
      var choiceValue = choice.id || choice.value;

      if (propIsMultienum) {
        return Array.from(selectedItems).includes(choiceValue);
      }

      return choiceValue === value;
    }).map(function (obj) {
      return obj.text;
    });
    displayValue = selected.join(', ');
  } else if (PropertyIdentifier.isDate(property) && value !== '' && value != null) {
    if (property.type === 'datetime') {
      displayValue = _I18n.default.moment.userTz(Number(value)).format('L LT z');
    } else {
      displayValue = _I18n.default.moment.utc(Number(value)).format('L');
    }
  } else if (PropertyIdentifier.isPercent(property)) {
    displayValue = _I18n.default.formatPercentage(value, {
      precision: 2
    });
  }

  return displayValue || value;
}